/* global attachEvent, YT */

attachEvent('.video--youtube .video__poster', 'click', (ev) => {
  let player;
  const number = Math.floor(Math.random() * 10000 + 1);
  const parent = ev.target.closest('.video--youtube');
  const videoURL = ev.target.closest('.video__poster').getAttribute('data-id');
  const idString = 'id_';
  const videoID = idString.concat('', number);
  const videoClose = parent.querySelector('.video__close');

  document.body.classList.add('noscroll');

  // Add class to parent for hiding poster
  parent.classList.add('is-playing');

  // Set the div ID to match API player ID
  parent.querySelectorAll('.video__iframe-container')[0].id = videoID;

  // API EVENT: Play
  function onPlayerReady(event) {
    event.target.playVideo();
  }

  // API EVENT: Check for ending
  function onPlayerStateChange(event) {
    if (event.data === 0) {
      // Stop and destroy player (stops video and removes player instance and iframe)
      parent.classList.remove('is-playing');
      player.stopVideo();
      player.destroy();
      player = null;
    }
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      parent.classList.remove('is-playing');
      player.stopVideo();
      player.destroy();
      player = null;
    }
  });
  videoClose.addEventListener('click', () => {
    parent.classList.remove('is-playing');
    player.stopVideo();
    player.destroy();
    player = null;
  });

  // API: Create new player
  player = new YT.Player(videoID, {
    // Set the api ID to match div ID
    videoId: videoURL,
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerStateChange,
    },
  });
});

// **************************************************

attachEvent('.video--media .video__poster', 'click', (ev) => {
  const parent = ev.target.closest('.video--media');
  const video = parent.querySelector('.video__src video');
  parent.classList.add('is-playing');
  video.play();
  const videoClose = parent.querySelector('.video__close');

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      parent.classList.remove('is-playing');
      video.pause();
      video.currentTime = 0;
    }
  });
  videoClose.addEventListener('click', () => {
    parent.classList.remove('is-playing');
    video.pause();
    video.currentTime = 0;
  });
});
